/**
 * J'ADORE INSTYTUT - Product Section JavaScript
 * Interaktywność dla sekcji produktowej Shopify
 */

const JadoreProduct = {
  // State
  currentSlide: 0,
  selectedCity: 'warszawa',
  
  // Data
  slides: [
    { 
      stat: '-67%', 
      label: 'cellulitu', 
      title: '10 ENDERMOLOGII + 4 ACCENT', 
      before: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=500&h=600&fit=crop&sat=-100', 
      after: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=500&h=600&fit=crop' 
    },
    { 
      stat: '+71%', 
      label: 'jędrności', 
      title: '15 ZABIEGÓW ENDERMOLOGII', 
      before: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=500&h=600&fit=crop&sat=-100', 
      after: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=500&h=600&fit=crop' 
    },
    { 
      stat: '-5,2cm', 
      label: 'obwodu', 
      title: 'ENDERMOLOGIA + STORZ', 
      before: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=600&fit=crop&sat=-100', 
      after: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=600&fit=crop' 
    }
  ],
  
  packages: {
    warszawa: [
      { name: '1 zabieg', perUnit: null, oldPrice: 300, price: 235, savings: 65, popular: false },
      { name: '5 zabiegów', perUnit: '279,80 zł / zabieg', oldPrice: 1500, price: 1399, savings: 101, popular: false },
      { name: '10 zabiegów', perUnit: '239,90 zł / zabieg', oldPrice: null, price: 2399, savings: null, popular: true },
      { name: '20 zabiegów', perUnit: '199,95 zł / zabieg', oldPrice: null, price: 3999, savings: null, popular: false }
    ],
    krakow: [
      { name: '1 zabieg', perUnit: null, oldPrice: 280, price: 219, savings: 61, popular: false },
      { name: '5 zabiegów', perUnit: '259,80 zł / zabieg', oldPrice: 1400, price: 1299, savings: 101, popular: false },
      { name: '10 zabiegów', perUnit: '219,90 zł / zabieg', oldPrice: null, price: 2199, savings: null, popular: true },
      { name: '20 zabiegów', perUnit: '184,95 zł / zabieg', oldPrice: null, price: 3699, savings: null, popular: false }
    ]
  },
  
  // Initialize
  init: function() {
    this.renderThumbnails();
    this.renderPricing();
    this.updateSlide();
    this.setupHoverEffects();
  },
  
  // Results Slider
  renderThumbnails: function() {
    const container = document.getElementById('jadore-results-thumbs');
    if (!container) return;
    
    container.innerHTML = this.slides.map((slide, i) => `
      <div class="jadore-results-thumb ${i === this.currentSlide ? 'active' : ''}" 
           onclick="JadoreProduct.goToSlide(${i})">
        <div class="jadore-results-thumb-value">${slide.stat}</div>
        <div class="jadore-results-thumb-label">${slide.label}</div>
      </div>
    `).join('');
  },
  
  updateSlide: function() {
    const slide = this.slides[this.currentSlide];
    
    // Update images
    const beforeImg = document.getElementById('jadore-before-img');
    const afterImg = document.getElementById('jadore-after-img');
    if (beforeImg) beforeImg.src = slide.before;
    if (afterImg) afterImg.src = slide.after;
    
    // Update stat
    const statValue = document.getElementById('jadore-stat-value');
    const statLabel = document.getElementById('jadore-stat-label');
    if (statValue) statValue.textContent = slide.stat;
    if (statLabel) statLabel.textContent = slide.label;
    
    // Update title
    const title = document.getElementById('jadore-results-title');
    if (title) title.textContent = slide.title;
    
    // Update thumbnails
    document.querySelectorAll('.jadore-results-thumb').forEach((thumb, i) => {
      thumb.classList.toggle('active', i === this.currentSlide);
    });
    
    // Update nav buttons
    const prevBtn = document.querySelector('.jadore-results-nav.prev');
    const nextBtn = document.querySelector('.jadore-results-nav.next');
    if (prevBtn) prevBtn.disabled = this.currentSlide === 0;
    if (nextBtn) nextBtn.disabled = this.currentSlide === this.slides.length - 1;
  },
  
  goToSlide: function(index) {
    this.currentSlide = index;
    this.updateSlide();
  },
  
  prevSlide: function() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
      this.updateSlide();
    }
  },
  
  nextSlide: function() {
    if (this.currentSlide < this.slides.length - 1) {
      this.currentSlide++;
      this.updateSlide();
    }
  },
  
  // City & Pricing
  selectCity: function(city) {
    this.selectedCity = city;
    
    // Update buttons
    document.querySelectorAll('.jadore-city-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.city === city);
    });
    
    this.renderPricing();
  },
  
  renderPricing: function() {
    const container = document.getElementById('jadore-pricing-body');
    if (!container) return;
    
    const packages = this.packages[this.selectedCity] || this.packages.warszawa;
    
    container.innerHTML = packages.map((pkg, i) => `
      <tr class="${pkg.popular ? 'popular' : ''}">
        <td>
          <div class="jadore-package-name ${pkg.popular ? 'popular' : ''}">
            <span>${pkg.name}</span>
            ${pkg.popular ? '<span class="jadore-bestseller-badge">BESTSELLER</span>' : ''}
          </div>
          ${pkg.perUnit ? `<div class="jadore-per-unit">${pkg.perUnit}</div>` : ''}
        </td>
        <td>
          ${pkg.oldPrice ? `<span class="jadore-old-price">${pkg.oldPrice} zł</span>` : ''}
        </td>
        <td>
          <span class="jadore-price">${pkg.price}</span>
          <span class="jadore-price-currency">zł</span>
        </td>
        <td>
          ${pkg.savings ? `<span class="jadore-savings-badge">-${pkg.savings} zł</span>` : ''}
        </td>
        <td>
          <button class="jadore-select-btn jadore-hover-lift" onclick="JadoreProduct.selectPackage('${pkg.name}', ${pkg.price})">
            WYBIERZ
          </button>
        </td>
      </tr>
    `).join('');
  },
  
  selectPackage: function(name, price) {
    // Tu można dodać integrację z koszykiem Shopify
    // Przykład: dodanie do koszyka
    console.log('Selected package:', name, price);
    
    // Opcjonalnie: scroll do sekcji zakupowej lub dodanie do koszyka
    // window.location.href = '/cart/add?id=VARIANT_ID&quantity=1';
    
    // Alternatywnie: pokazanie powiadomienia
    alert(`Wybrałaś pakiet: ${name} za ${price} zł\n\nSkontaktuj się z nami, aby zarezerwować zabiegi.`);
  },
  
  // Modal
  openModal: function() {
    const modal = document.getElementById('jadore-modal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  },
  
  closeModal: function() {
    const modal = document.getElementById('jadore-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  },
  
  // Video
  playVideo: function() {
    // Tu można dodać integrację z YouTube/Vimeo
    // Przykład: otwarcie w nowym oknie lub embed
    console.log('Play video');
    // window.open('https://youtube.com/watch?v=VIDEO_ID', '_blank');
  },
  
  // Hover Effects
  setupHoverEffects: function() {
    // Steps hover
    document.querySelectorAll('.jadore-step').forEach(step => {
      step.addEventListener('mouseenter', function() {
        this.querySelector('.jadore-step-icon').style.background = 'linear-gradient(135deg, #ddd5c8 0%, #c4b599 100%)';
        this.querySelector('.jadore-step-icon').style.boxShadow = '0 8px 28px rgba(196, 181, 153, 0.2)';
      });
      step.addEventListener('mouseleave', function() {
        this.querySelector('.jadore-step-icon').style.background = '#f5f2ed';
        this.querySelector('.jadore-step-icon').style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
      });
    });
    
    // Pricing rows hover
    document.querySelectorAll('#jadore-pricing-body tr').forEach(row => {
      row.addEventListener('mouseenter', function() {
        this.style.background = '#f5f2ed';
      });
      row.addEventListener('mouseleave', function() {
        if (this.classList.contains('popular')) {
          this.style.background = 'rgba(245, 242, 237, 0.6)';
        } else {
          this.style.background = 'transparent';
        }
      });
    });
    
    // Video chapters
    document.querySelectorAll('.jadore-video-chapter').forEach(chapter => {
      chapter.addEventListener('click', function() {
        document.querySelectorAll('.jadore-video-chapter').forEach(c => c.classList.remove('active'));
        this.classList.add('active');
      });
    });
  },
  
  // Escape key to close modal
  handleKeydown: function(e) {
    if (e.key === 'Escape') {
      this.closeModal();
    }
  }
};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  JadoreProduct.init();
});

// Escape key listener
document.addEventListener('keydown', function(e) {
  JadoreProduct.handleKeydown(e);
});

// Re-initialize on Shopify section reload (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.jadore-product-section')) {
      JadoreProduct.init();
    }
  });
}
